import {
  LEFT_MENU_WIDTH,
  LEFT_MENU_WIDTH_MAX,
  LEFT_MENU_WIDTH_MIN,
  lgDynamicPadding,
  MAX_CONTENT_WIDTH,
  MAX_MD_CONTENT_WIDTH,
  MAX_PAGE_WIDTH,
  MAX_XS_CONTENT_WIDTH,
  maxPadding,
  mdDynamicPadding,
  minPadding,
  PAGE_RIGHT_MENU_DESKTOP_WIDTH,
  smDynamicPadding,
} from '@/constants/UIWrapperConstants';
import { useScreen } from '@/hooks/useScreen';

export const useUIWrapper = () => {
  const { xl, lg, md, sm } = useScreen();

  const leftMenuWidth = `clamp(${LEFT_MENU_WIDTH_MIN}px,${LEFT_MENU_WIDTH},${LEFT_MENU_WIDTH_MAX}px)`;
  const pageRightMenuWidth = md ? PAGE_RIGHT_MENU_DESKTOP_WIDTH : PAGE_RIGHT_MENU_DESKTOP_WIDTH + 30;
  const containerPadding = xl
    ? maxPadding
    : lg
    ? lgDynamicPadding
    : md
    ? mdDynamicPadding
    : sm
    ? smDynamicPadding
    : minPadding;
  const containerMaxWidth = lg ? MAX_CONTENT_WIDTH : md ? MAX_MD_CONTENT_WIDTH : MAX_XS_CONTENT_WIDTH;

  return {
    MAX_PAGE_WIDTH,
    leftMenuWidth,
    pageRightMenuWidth,
    containerPadding,
    containerMaxWidth,
  };
};
